/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_OfficeInputs */

const en_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office`)
};

const es_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oficina`)
};

const fr_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bureau`)
};

const de_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Büro`)
};

const ja_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフィス`)
};

const zh_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`办公室`)
};

const ar_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المكتب`)
};

const id_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kantor`)
};

const it_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ufficio`)
};

const ru_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Офис / Кабинет`)
};

const pt_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escritório`)
};

const ko_val_office = /** @type {(inputs: Val_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사무실`)
};

/**
* | output |
* | --- |
* | "Office" |
*
* @param {Val_OfficeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_office = /** @type {((inputs?: Val_OfficeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_OfficeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_office(inputs)
	if (locale === "es") return es_val_office(inputs)
	if (locale === "fr") return fr_val_office(inputs)
	if (locale === "de") return de_val_office(inputs)
	if (locale === "ja") return ja_val_office(inputs)
	if (locale === "zh") return zh_val_office(inputs)
	if (locale === "ar") return ar_val_office(inputs)
	if (locale === "id") return id_val_office(inputs)
	if (locale === "it") return it_val_office(inputs)
	if (locale === "ru") return ru_val_office(inputs)
	if (locale === "pt") return pt_val_office(inputs)
	return ko_val_office(inputs)
});